"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("core-js/modules/es6.regexp.to-string");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _customizePagePopup = _interopRequireDefault(require("./components/customizePagePopup.vue"));
var _customizePageManagement = require("@/api/operationManagement/customizePageManagement");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'CustomizePageManagement',
  components: {
    customizePagePopup: _customizePagePopup.default
  },
  data: function data() {
    return {
      listLoading: false,
      pagination: {
        total: 0 // 条数
      },
      queryData: {
        title: '',
        page: {
          page: 1,
          size: 10
        }
      },
      tableList: []
    };
  },
  created: function created() {
    this.pageListPage();
  },
  methods: {
    copyText: function () {
      var _copyText = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(text) {
        var _this = this;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              try {
                this.$copyText(text.toString()).then(function () {
                  _this.$notify.success({
                    title: '温馨提示',
                    message: '拷贝成功'
                  });
                }).catch(function () {
                  _this.$notify.success({
                    title: '温馨提示',
                    message: '拷贝失败，请手动复制'
                  });
                });
              } catch (err) {
                alert('拷贝失败，请手动复制');
                this.$notify.success({
                  title: '温馨提示',
                  message: '拷贝失败，请手动复制'
                });
              }
            case 1:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function copyText(_x) {
        return _copyText.apply(this, arguments);
      }
      return copyText;
    }(),
    onAdd: function onAdd() {
      this.$refs.customizePagePopup.open({
        type: 'add',
        name: '自定义页面添加'
      });
    },
    onEditor: function onEditor(data) {
      this.$refs.customizePagePopup.open({
        type: 'editor',
        name: '自定义页面编辑',
        item: data
      });
    },
    onDelete: function onDelete(data) {
      var _this2 = this;
      this.$confirm('是否确认删除此自定义页面?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this2.pageDeletePage(data.id);
      });
    },
    onRefresh: function onRefresh() {
      this.queryData.page.size = 10;
      this.queryData.page.page = 1;
      this.pageListPage();
    },
    onInquire: function onInquire() {
      this.queryData.page.size = 10;
      this.queryData.page.page = 1;
      this.pageListPage();
    },
    onInitialize: function onInitialize() {
      this.queryData.page.size = 10;
      this.queryData.page.page = 1;
      this.queryData.title = '';
      this.pageListPage();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.queryData.page.size = val;
      this.pageListPage();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.queryData.page.page = val;
      this.pageListPage();
    },
    pageListPage: function () {
      var _pageListPage2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var params, res, _t;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              this.listLoading = true;
              params = (0, _objectSpread2.default)({}, this.queryData);
              _context2.n = 1;
              return (0, _customizePageManagement.pageListPage)(params);
            case 1:
              res = _context2.v;
              if (res.code === 0) {
                console.log('res', res);
                this.tableList = res.data.data;
                this.pagination.total = res.data.total;
              }
              this.listLoading = false;
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t = _context2.v;
              console.log(_t);
              this.listLoading = false;
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function pageListPage() {
        return _pageListPage2.apply(this, arguments);
      }
      return pageListPage;
    }(),
    pageDeletePage: function () {
      var _pageDeletePage2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3(id) {
        var params, res, _t2;
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              params = {
                id: id
              };
              _context3.n = 1;
              return (0, _customizePageManagement.pageDeletePage)(params);
            case 1:
              res = _context3.v;
              if (res.code === 0) {
                this.$notify.success({
                  title: '温馨提示',
                  message: '删除成功'
                });
                this.onInquire();
              }
              _context3.n = 3;
              break;
            case 2:
              _context3.p = 2;
              _t2 = _context3.v;
              console.log(_t2);
            case 3:
              return _context3.a(2);
          }
        }, _callee3, this, [[0, 2]]);
      }));
      function pageDeletePage(_x2) {
        return _pageDeletePage2.apply(this, arguments);
      }
      return pageDeletePage;
    }()
  }
};